import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-zayan-border bg-zayan-bgLight">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-start gap-4 md:gap-6 py-6 px-6">
        {/* Logo */}
        <img
          src="https://public.readdy.ai/ai/img_res/9d779e00-88f8-4b7d-bab2-ddc07fc3eeec.png"
          alt="Zayan Atelier"
          className="h-16 md:h-24 w-auto"
        />
        <span className="hidden md:inline text-zayan-borderLight">|</span>
        <span className="text-zayan-textMuted text-xs tracking-[0.2em] font-sans">
          REFINED · RARE · RADIANT.
        </span>
        <span className="hidden md:inline text-zayan-borderLight">|</span>
        <span className="text-zayan-textMuted text-xs font-sans">
          &copy; 2026 Zayan Atelier. All Rights Reserved.
        </span>
        <span className="hidden md:inline text-zayan-borderLight">|</span>
        <Link
          to="/terms-and-conditions"
          className="text-zayan-textMuted text-xs font-sans hover:text-zayan-gold transition-colors whitespace-nowrap"
        >
          Full terms and conditions
        </Link>
        <span className="hidden md:inline text-zayan-borderLight">|</span>
        <Link
          to="/privacy-policy"
          className="text-zayan-textMuted text-xs font-sans hover:text-zayan-gold transition-colors whitespace-nowrap"
        >
          Privacy Policy
        </Link>
      </div>
    </footer>
  );
}